import dayjs from 'Shared/dayjs';

import { dateOnlySlashesFormat, dateTimeSlashesFormat } from 'App/services/DateService';

const acceptedDateFormats = [dateTimeSlashesFormat, dateOnlySlashesFormat];

/**
 * Sorts columns holding localized date strings. The default `alphanumeric` sort compares
 * MM/DD/YYYY values character by character, which orders them by month rather than by date.
 * Invalid or missing dates sort ahead of real dates when ascending.
 */
const sortLocalizedDate = (rowA, rowB, columnId) => {
    const dateA = dayjs(rowA.values[columnId], acceptedDateFormats);
    const dateB = dayjs(rowB.values[columnId], acceptedDateFormats);

    if (!dateA.isValid()) {
        return dateB.isValid() ? -1 : 0;
    }
    if (!dateB.isValid()) {
        return 1;
    }

    return dateA.diff(dateB);
};

export { sortLocalizedDate };
